import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import arrowLeftIcon from '@/core/svg/fa/arrow-left.svg';
import { SvgIcon } from '@/core/ui';
import { BackButtonLink } from './BackLink.styled';
const BackLink = ({ label, to, relative = 'path', ...props }) => {
    return (_jsxs(BackButtonLink, { component: Link, relative: relative, to: to, ...props, children: [_jsx(SvgIcon, { icon: arrowLeftIcon, size: "sm" }), label] }));
};
export { BackLink };
